var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"pc"},[_c('div',{staticClass:"body"},[_c('img',{attrs:{"src":_vm.logo,"width":"130","height":"47"}}),_c('div',{staticClass:"nav"},[_c('footer-nav',{attrs:{"data":_vm.navData}})],1)])]),_c('div',{staticClass:"h5"}),_c('copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }